import { render } from "./InlineFileUploader.vue?vue&type=template&id=2dad0ee1&scoped=true&ts=true"
import script from "./InlineFileUploader.vue?vue&type=script&lang=ts"
export * from "./InlineFileUploader.vue?vue&type=script&lang=ts"

import "./InlineFileUploader.vue?vue&type=style&index=0&id=2dad0ee1&scoped=true&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2dad0ee1"]])

export default __exports__